import React from 'react';

/**
 * خلفية إسلامية أصيلة مستوحاة من زخارف وزليج المصحف الشريف
 * (Authentic Islamic Geometric Girih Pattern & Mihrab Ambient Lighting)
 */
export default function QuranAmbientBackdrop() {
  return (
    <div
      className="quran-ambient-backdrop pointer-events-none fixed inset-0 z-0 overflow-hidden select-none"
      aria-hidden="true"
    >
      {/* 1. Authentic Islamic Geometric Girih Tessellation Pattern */}
      <svg
        className="absolute inset-0 w-full h-full opacity-60 dark:opacity-30"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="islamic-girih-pattern"
            x="0"
            y="0"
            width="80"
            height="80"
            patternUnits="userSpaceOnUse"
          >
            {/* Orthogonal and Diagonal Grid Lines */}
            <path
              d="M40 0 L40 80 M0 40 L80 40 M0 0 L80 80 M80 0 L0 80"
              stroke="#c59b27"
              strokeWidth="0.6"
              strokeOpacity="0.18"
              fill="none"
            />

            {/* Central 8-Pointed Star (Rub el Hizb) */}
            <polygon
              points="40,22 45.2,34.8 58,40 45.2,45.2 40,58 34.8,45.2 22,40 34.8,34.8"
              fill="none"
              stroke="#c59b27"
              strokeWidth="0.9"
              strokeOpacity="0.32"
            />
            <polygon
              points="40,27.3 52.7,27.3 52.7,52.7 40,52.7 27.3,52.7 27.3,27.3"
              fill="none"
              stroke="#c9aa70"
              strokeWidth="0.7"
              strokeOpacity="0.22"
              transform="rotate(45 40 40)"
            />

            {/* Octagonal Medallion Frame */}
            <polygon
              points="40,8 62.6,17.4 72,40 62.6,62.6 40,72 17.4,62.6 8,40 17.4,17.4"
              fill="none"
              stroke="#c59b27"
              strokeWidth="0.6"
              strokeOpacity="0.16"
            />

            {/* Corner Star Elements (meet to form complete stars across tiles) */}
            <path
              d="M0,18 L5.2,5.2 L18,0 M80,18 L74.8,5.2 L62,0 M0,62 L5.2,74.8 L18,80 M80,62 L74.8,74.8 L62,80"
              fill="none"
              stroke="#c59b27"
              strokeWidth="0.8"
              strokeOpacity="0.28"
            />
          </pattern>
        </defs>

        <rect width="100%" height="100%" fill="url(#islamic-girih-pattern)" />
      </svg>

      {/* 2. Top Mihrab Light Aura (هالة نور المحراب العلوي) */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[360px] bg-gradient-to-b from-[#c59b27]/12 via-amber-500/5 to-transparent rounded-full blur-3xl pointer-events-none" />

      {/* 3. Side Ambient Emerald & Gold Radiance */}
      <div className="absolute top-1/4 end-0 w-[500px] h-[500px] bg-gradient-to-bl from-[#c59b27]/8 via-transparent to-transparent rounded-full blur-3xl pointer-events-none" />
      <div className="absolute bottom-1/4 start-0 w-[500px] h-[500px] bg-gradient-to-tr from-[#c9aa70]/6 via-transparent to-transparent rounded-full blur-3xl pointer-events-none" />

      {/* 4. Luxury Islamic Outer Margin Frames (حواشي المصحف الشريف الجانبية) */}
      <div className="hidden 2xl:block absolute top-12 bottom-12 start-8 w-px bg-gradient-to-b from-transparent via-[#c59b27]/25 to-transparent pointer-events-none" />
      <div className="hidden 2xl:block absolute top-12 bottom-12 end-8 w-px bg-gradient-to-b from-transparent via-[#c59b27]/25 to-transparent pointer-events-none" />
    </div>
  );
}
